import "react";
import { jsxs } from "react/jsx-runtime";
//#region src/components/IdLabel/index.tsx
var IdLabel = ({ className, idLabel }) => {
	if (!idLabel) return null;
	return /* @__PURE__ */ jsxs("span", {
		className,
		children: ["#", idLabel]
	});
};
//#endregion
export { IdLabel };

//# sourceMappingURL=index.js.map